// Shown if a part of the app could not be downloaded (offline, or a deploy happened and the one automatic reload in
// utils/lazyWithRetry.js did not fix it). Without this a failed download is a blank white page.
import { Component } from "react";

export default class ChunkErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error("App part failed to load:", error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ display: "flex", height: "100vh", background: "#0B1120", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif" }}>
        <div style={{ textAlign: "center", maxWidth: 360, padding: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>📡</div>
          <div style={{ color: "#E5A822", fontSize: 16, fontWeight: 600, marginBottom: 8 }}>This part of the app could not load</div>
          <div style={{ color: "#8899AA", fontSize: 13, marginBottom: 18 }}>Check your connection, then reload. Nothing you entered has been lost.</div>
          <button onClick={() => window.location.reload()} style={{ padding: "10px 22px", borderRadius: 8, border: "none", background: "#E5A822", color: "#0B1120", fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Reload</button>
        </div>
      </div>
    );
  }
}
